import React, { useEffect, useState } from "react"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"
import PageLoader from "./../../../assets/loading/pageLoad1.gif"

const AddTransportBill = () => {
  const user = localStorage.getItem("authUser")
  const userInfo = user ? JSON.parse(user) : {}
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [transporters, setTransporters] = useState([])
  const [vehicles, setVehicles] = useState([])
  const [fuel, setFuel] = useState("0")
  const [toll, setToll] = useState("0")
  const [other, setOther] = useState("0")
  const [autoTotal, setAutoTotal] = useState("0.00")

  useEffect(() => { getData() }, [])

  useEffect(() => {
    const total = (parseFloat(fuel)||0) + (parseFloat(toll)||0) + (parseFloat(other)||0)
    setAutoTotal(total.toFixed(2))
  }, [fuel, toll, other])

  const getData = async () => {
    try {
      const [tResp, vResp] = await Promise.all([
        api.get("transporters?per_page=500"),
        api.get("vehicles?per_page=500")
      ])
      setTransporters(Array.isArray(tResp.data?.data) ? tResp.data.data : tResp.data?.data?.data || [])
      setVehicles(Array.isArray(vResp.data?.data) ? vResp.data.data : vResp.data?.data?.data || [])
    } catch (e) { console.error(e) }
    setPageLoad(false)
  }

  const handleValidSubmit = async (event, values) => {
    if (values.billFrom && values.billTo && values.billFrom > values.billTo) {
      alert("Bill Period 'From' must be before 'To'"); return
    }
    values.added_by = userInfo.uid
    // Auto-sum if billAmount not manually entered
    if (!values.billAmount || parseFloat(values.billAmount) === 0) {
      values.billAmount = autoTotal
    }
    setLoading(true); setSubmitted(false)
    try {
      const resp = await api.post("create-transport-bill", values)
      if (resp.data.success) { setSubmitted(true); setTimeout(() => setSubmitted(false), 4000) }
    } catch (e) { console.error(e) }
    setLoading(false)
  }

  const today = new Date().toISOString().split("T")[0]
  if (pageLoad) return <div className="pageLoader"><img src={PageLoader} alt="Loading..." /></div>

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Add Transport Bill</h4></Col>
          <Col md={6} style={{textAlign:"right"}}><Link to="/transport-bills" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link></Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm className="form-horizontal" onValidSubmit={(e,v)=>handleValidSubmit(e,v)}>
          <h6 style={{color:"#6366f1",borderBottom:"2px solid #e2e8f0",paddingBottom:"8px",marginBottom:"16px"}}><i className="fas fa-truck"></i> Transport Details</h6>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="billDate" label="Bill Date" type="date" value={today} required /></div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="transporter" label="Transporter" required>
                <option value="">Select Transporter</option>
                {transporters.map((t,i) => <option key={i} value={t.id}>{t.transporterName}</option>)}
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="vehicle" label="Vehicle" required>
                <option value="">Select Vehicle</option>
                {vehicles.map((v,i) => <option key={i} value={v.id}>{v.driverName} — {v.vehicleNumber}</option>)}
              </AvField>
            </div></Col>
          </Row>

          <h6 style={{color:"#6366f1",borderBottom:"2px solid #e2e8f0",paddingBottom:"8px",marginBottom:"16px",marginTop:"8px"}}><i className="fas fa-calendar-alt"></i> Billing Period</h6>
          <Row>
            <Col md={6}><div className="mb-3"><AvField name="billFrom" label="Period From" type="date" required /></div></Col>
            <Col md={6}><div className="mb-3"><AvField name="billTo" label="Period To" type="date" required /></div></Col>
          </Row>

          <h6 style={{color:"#6366f1",borderBottom:"2px solid #e2e8f0",paddingBottom:"8px",marginBottom:"16px",marginTop:"8px"}}><i className="fas fa-rupee-sign"></i> Charges Breakdown</h6>
          <Row>
            <Col md={3}><div className="mb-3"><AvField name="fuelCharges" label="Fuel Charges (₹)" type="number" step="0.01" value="0" validate={{min:{value:0}}} onChange={e=>setFuel(e.target.value)} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="tollCharges" label="Toll Charges (₹)" type="number" step="0.01" value="0" validate={{min:{value:0}}} onChange={e=>setToll(e.target.value)} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="otherCharges" label="Other Charges (₹)" type="number" step="0.01" value="0" validate={{min:{value:0}}} onChange={e=>setOther(e.target.value)} /></div></Col>
            <Col md={3}><div className="mb-3">
              <label className="form-label">Auto Total (₹)</label>
              <div style={{padding:"8px 12px",background:"#f0fdf4",border:"1px solid #bbf7d0",borderRadius:"6px",fontWeight:"700",fontSize:"16px",color:"#166534"}}>₹ {autoTotal}</div>
              <small className="text-muted">Sum of fuel + toll + other</small>
            </div></Col>
          </Row>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="billAmount" label="Bill Amount Override (₹)" type="number" step="0.01" value="0" validate={{min:{value:0}}} helpMessage="Leave 0 to use auto-total above" /></div></Col>
            <Col md={8}><div className="mb-3"><AvField name="remarks" label="Remarks" type="textarea" rows="2" /></div></Col>
          </Row>

          <div className="mb-3 row mt-4">
            <div className="col-6">{submitted && <UncontrolledAlert color="success"><strong>Transport Bill Added!</strong></UncontrolledAlert>}</div>
            <div className="col-6 text-end">
              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner animation="border" size="sm" /><span style={{paddingLeft:"10px"}}>Saving...</span></> : <span><i className="fas fa-save"></i> Save Bill</span>}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}
export default AddTransportBill
